<template>
  <apexchart ref="realtimeChart" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
export default {
  name: 'ApexMultipleYaxis',
  data() {
    return {
      series: [{
        name: 'Income',
        type: 'column',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      // {
      //   name: 'Cashflow',
      //   type: 'column',
      //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      // }, {
      //   name: 'Revenue',
      //   type: 'line',
      //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      // }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          stacked: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          // width: [1, 1, 4]
        },
        title: {
          text: 'Multiple Y Axis',
          align: 'left',
          style: {
            color: '#fff'
          }
        },
        xaxis: {
          categories: ['Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          labels: {
            style: {
              colors: '#FFF'
            }
          }
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                colors: '#008FFB'
              }
            },
            tooltip: {
              enabled: true
            }
          },
          {
            seriesName: 'Income',
            opposite: true,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#00E396'
            },
            labels: {
              style: {
                colors: '#00E396'
              }
            }
          },
          // {
          //   seriesName: 'Revenue',
          //   opposite: true,
          //   axisTicks: {
          //     show: true
          //   },
          //   axisBorder: {
          //     show: true,
          //     color: '#FEB019'
          //   },
          //   labels: {
          //     style: {
          //       colors: '#FEB019'
          //     }
          //   }
          // }
        ],
        tooltip: {
          fixed: {
            enabled: true,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          }
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 40,
          labels: {
            colors: '#FFF'
          }
        }
      }
    }
  },
  methods: {
    // loadData(value) {
    //   console.log(value)
    //   this.series[0].data = []
    //   // this.series[1].data = []
    //   // this.series[2].data = []
    //   // for (let index = 0; index < value.length; index++) {
    //   //   this.series[0].data.push(value[index].beneficios)
    //   // }
    //   // // console.log(value)
    //   // // console.log(this.series[0].data)
    //   let beneficios = []
    //   for (let index = 0; index < value.length; index++) {
    //     beneficios.push(value[index].beneficios.toFixed(2))
    //     this.series[0].data.push(value[index].beneficios.toFixed(2))
    //   }
    //   console.log(beneficios)
    //   // this.series[0] = [{
    //   //   data: beneficios
    //   // }]

    //   console.log(this.$refs.chart)
    //   // this.$refs.chart.updateSeries(beneficios)
    //   this.$refs.chart.render()
    // },
    updateSeriesLine(value) {
      console.log(value)
      let beneficios = []
      this.series[0].data = []
      for (let index = 0; index < value.length; index++) {
        beneficios.push(value[index].beneficios.toFixed(2))
        // this.series[0].data.push(value[index].beneficios.toFixed(2))
      }
      
      // this.$refs.realtimeChart.updateSeries([{
      //   data: this.series[0].data,
      // }], false, true);

      // In the same way, update the series option
      this.series[0].data = beneficios
      // this.series[0] = [{
      //   data: beneficios
      // }]

      console.log(this.series[0].data)
    },
  }
}
</script>